import React from 'react';
import { FormProvider } from 'forms';
import { AddEmployeeFieldModalProps, EmployeeFieldFormData } from '../../types';
import { getEmployeeFieldFormData } from '../../utils';
import { AddEmployeeFieldModalContent } from './AddEmployeeFieldModalContent';

export const AddEmployeeFieldModal = (props: AddEmployeeFieldModalProps) => (
  <FormProvider<EmployeeFieldFormData>
    initialState={getEmployeeFieldFormData(props.mode === 'edit' ? props.initialField : null)}>
    <AddEmployeeFieldModalContent {...props} />
  </FormProvider>
);
